module.exports = require('./lib/linkify-react');